export enum PendStatus {
  New = 1,
  InProgress = 2,
  Resolved = 3,
  Closed = 4,
}
